import { render, staticRenderFns } from "./VueloModal.vue?vue&type=template&id=5564e372&scoped=true"
import script from "./VueloModal.vue?vue&type=script&lang=js"
export * from "./VueloModal.vue?vue&type=script&lang=js"
import style0 from "./VueloModal.vue?vue&type=style&index=0&id=5564e372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564e372",
  null
  
)

export default component.exports